/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Réponse d\'erreur avec message et code de statut
 */
export const errorResponseSchema = z.object({
      "message": z.string().describe("Message détaillé de l'erreur").optional(),
  "status": z.number().int().describe("Code de statut HTTP associé à l'erreur").optional()
      }).describe("Réponse d'erreur avec message et code de statut")